import { useContext } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider, AppContext } from './context/AppContext';
import { LoginPage } from './pages';
import { AuthenticatedLayout } from './components/layout/AuthenticatedLayout';
import { Toast } from './components/common';
import { AddUserModal, OnboardingModal, UploadTrainingDocModal } from './components/modals';

/**
 * Root App Component
 * Wraps everything in BrowserRouter + AppContext Provider
 */
export default function App() {
  return (
    <BrowserRouter>
      <AppProvider>
        <AppRoutes />
      </AppProvider>
    </BrowserRouter>
  );
}

/**
 * Route Definitions
 * - /login for unauthenticated users
 * - /:role/* for authenticated users (role-based paths)
 * - All other paths redirect to /login
 */
function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPageWithToast />} />
      <Route path="/:role/*" element={<AuthenticatedLayout />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

/**
 * LoginPage wrapper that includes Toast notifications
 */
function LoginPageWithToast() {
  const { toast } = useContext(AppContext);
  return (
    <>
      <LoginPage />
      {toast && <Toast msg={toast.msg} type={toast.type} />}
    </>
  );
}
